// extracted by mini-css-extract-plugin
export default {"project-types-wrapper":"ProjectTypesPanel_project-types-wrapper__ev+rW","link":"ProjectTypesPanel_link__vs2e9"};